import {useEffect, useMemo, useState} from "react";
import store from "storejs";
import {ONE_TIME, RECURRING} from "../Constants/PaymentTypes";

export const useMethodData = (watchPaymentMethod) => {
    const [currency, setCurrency] = useState('EUR');
    const [fee, setFee] = useState(null);
    const methods = useMemo(() => {
        const merged = {};
        const data = store(ONE_TIME);
        if (data) {
            Object.values(data).forEach(data =>
                data.forEach(o => Object.assign(merged[o.id] ??= {}, o))
            );
        }

        const recurring = store(RECURRING) || [];

        return [...recurring, ...Object.values(merged)];
    }, []);

    useEffect(() => {
        const method = methods.find(item => parseInt(item.id) === parseInt(watchPaymentMethod));

        if (method) {
            setCurrency(method.currencies[0] ?? '');
            setFee(method.fee)
        }
    }, [watchPaymentMethod, methods]);

    return {currency, fee};
}
